<template>
	<div ref="tablePage" style="height: 100%">
		<!-- 面包屑导航 -->
		<div class="topNav">
			<div class="navFormWrapper">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
					<el-breadcrumb-item>费用管理</el-breadcrumb-item>
				</el-breadcrumb>
				<el-form ref="queryForm" :model="searchForm" inline label-width="68px" style="margin-left: 6vh">
					<el-form-item style="margin-bottom: 0">
						<el-select v-model="searchForm.xiaoqu_id" placeholder="请选择小区" clearable style="width: 100%"
							size="small" filterable @change="searchChange" @clear="searchXiaoquClearInput">
							<el-option v-for="item in regionArr" :key="item.id" :label="item.xiaoqu_name"
								:value="item.xiaoqu_id" />
						</el-select>
					</el-form-item>
				</el-form>
			</div>
		</div>
		<el-table :data="tableList" style="width: 100%; margin-top: 2vh" border size="mini"
			:header-cell-style="{background: '#fff',height: '50px',color: '#909399',fontSize: '16px',fontFamily: 'Arial, sans-serif'}">
			<el-table-column prop="id" label="ID" align="center" />
			<el-table-column prop="xiaoqu_title" label="小区" align="center" />
			<el-table-column prop="xiaoqu_balance" label="余额" align="center" />
			<el-table-column prop="ope_acc_type" label="管理人" align="center" />
			<el-table-column prop="ope_acc_name" label="类型" align="center" />
			<el-table-column prop="amount_str" label="金额" align="center" />
			<el-table-column prop="update_time" label="时间" align="center" />
			<el-table-column fixed="right" label="操作" align="center">
				<template slot-scope="scope">
					<el-button @click.native.prevent="handleClick(scope.row)" type="primary" size="small"
						icon="el-icon-edit">
						修改
					</el-button>
				</template>
			</el-table-column>
		</el-table>
		<pagination v-show="total > 0" :total="total" :page.sync="searchForm.page" :limit.sync="searchForm.pageSize"
			@pagination="initList" />
		<el-dialog :title="title" :visible.sync="addOrEditOpen" :close-on-click-modal="false" width="45%"
			class="dialogHeight2 global-dialog-position" :before-close="getout" :lock-scroll="false"
			:append-to-body="true" style="margin-top: -10vh">
			<el-form ref="form" :model="form" label-width="108px" :rules="rules">
				<el-row>
					<el-col :span="24">
						<el-form-item label="小区" prop="xiaoqu_title">
							<el-input v-model="form.xiaoqu_title" autocomplete="off" disabled placeholder="请输入" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="金额" prop="amount">
							<el-input v-model="form.amount" autocomplete="off" placeholder="请输入金额" />
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submitForms">确 定</el-button>
				<el-button @click="getout">取 消</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import tableCommon from "../../../mixins/table-common";
	import {
		getFeiyongList,
		editFeiyong,
	} from "../../api/feiyong";
	import {
		getcarList
	} from "../../api/garage";

	export default {
		mixins: [tableCommon],
		data() {
			return {
				// 请求地址api
				api: {
					list: getFeiyongList,
					edit: editFeiyong,
				},
				// 规则验证
				rules: {
					amount: [{
						required: true,
						message: "请输入金额",
						trigger: "blur"
					}],
				},
				// 传参
				form: {},
				// 弹窗标题
				title: "新增",
				addOrEditOpen: false,
				// 查询参数
				searchForm: {
					page: 1,
					pageSize: 15,
					xiaoqu_id: ''
				},
				tableData: [],
				regionArr: [],
			};
		},
		mounted() {
			const form = {
				select: 1,
			};
			getcarList(form).then((res) => {
				this.regionArr = res.data.records.filter((item, index, self) => {
					return self.findIndex((t) => t.xiaoqu_id === item.xiaoqu_id) === index;
				});
				this.regionArr.forEach((item, index) => item.xiaoqu_id = item.xiaoqu_id.toString());
				console.log(this.regionArr)
			});
		},
		methods: {
			searchXiaoquClearInput() {
				this.searchForm.xiaoqu_id = '';
				this.searchChange();
			},
			findXiaoqu(xiaoqu_id) {
				let xiaoqu = this.regionArr.find(item => item.xiaoqu_id == xiaoqu_id);
				return xiaoqu ? xiaoqu.xiaoqu_name : '';
			},
			// 重置
			reset() {
				this.form = {};
			},
			// 修改弹窗
			handleClick(row) {
				this.title = "修改";
				this.form = JSON.parse(JSON.stringify(row));
				console.log('行修改点击：', this.form);

				this.handleEdit();
			},
			// 点击确定
			submitForms() {
				console.log('===================form:',this.form)
				try {
					// 提交表单
					this.submitForm(this.form);
				} catch (error) {
					// 处理提交失败的情况
					this.$message.error('提交失败');
					console.error("提交失败:", error);
					// 执行适当的操作，例如显示错误提示信息或进行其他处理
				}
			},
			// 关闭复制弹窗
			copyout() {
				this.copyIf = false;
				this.$refs.copyForm.clearValidate();
			},
			// 关闭弹窗
			getout() {
				this.addOrEditOpen = false;
				this.$refs.form.clearValidate();
			},
		},
	};
</script>
<style scoped>
	/deep/.dialogHeight2 .el-dialog__body {
		overflow-y: auto;
	}

	/deep/.dialogHeight .el-dialog__body {
		height: 100%;
		overflow: hidden;
	}

	/deep/.dialogHeightX .el-dialog__body {
		height: 100%;
		overflow: hidden;
	}

	/deep/.el-table,
	.el-table th,
	.el-table td {
		border-radius: 10px;
		-webkit-font-smoothing: antialiased;
		text-rendering: optimizeLegibility;
		font-size: 16px;
		font-family: Times, "Times New Roman";
		/* font-weight: 600; */
	}

	/deep/ .right-aligned-input .el-input__inner {
		text-align: right;
	}

	/deep/ .right-aligned-input .el-input__suffix {
		right: 0;
	}

	.topNav {
		display: flex;
		align-items: center;
		justify-content: space-between;
		background: #fff;
		padding: 20px 20px;
		border-radius: 10px;
	}

	.navFormWrapper {
		display: flex;
		align-items: center;
	}

	.uploadSty .el-upload--picture-card {
		width: 110px;
		height: 110px;
		line-height: 110px;
	}

	/deep/.disUploadSty .el-upload--picture-card {
		display: none;
		/* 上传按钮隐藏 */
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409eff;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 150px;
		height: 150px;
		line-height: 150px;
		text-align: center;
		border: 1px solid #dcdfe6;
	}

	.avatar {
		width: 150px;
		height: 150px;
		display: block;
	}

	.avatar-wrapper {
		position: relative;
	}

	.el-icon-close {
		position: absolute;
		top: 18px;
		right: 28vh;
		cursor: pointer;
	}

	.el-icon-close:hover {
		color: #409eff;
	}

	.avatar-wrapper .el-icon-close {
		position: absolute;
		top: 5px;
		right: 5px;
		font-size: 18px;
		color: #fff;
		background-color: rgba(0, 0, 0, 0.5);
		padding: 5px;
		border-radius: 50%;
		cursor: pointer;
	}


	/deep/ .el-dialog__body {
		height: 60vh;
	}
</style>


// WEBPACK FOOTER //
// src/views/feiyong/index.vue